import { POS_SALE_AUDIT_ACTIONS } from "@/modules/merchant/domain/repo/pos-sale-audit.constants";

const LABELS: Record<string, string> = {
  [POS_SALE_AUDIT_ACTIONS.CHECKOUT]: "ຊຳລະ / ຂາຍ",
  [POS_SALE_AUDIT_ACTIONS.HOLD_CREATED]: "ພັກບິນ",
  [POS_SALE_AUDIT_ACTIONS.HOLD_CONFIRMED]: "ຢືນຢັນພັກບິນ",
  [POS_SALE_AUDIT_ACTIONS.HOLD_ABANDONED]: "ຍົກເລີກພັກບິນ",
  [POS_SALE_AUDIT_ACTIONS.PAYMENT_ADDED]: "ເພີ່ມການຊຳລະ",
  [POS_SALE_AUDIT_ACTIONS.VOIDED]: "ຍົກເລີກບິນ",
  [POS_SALE_AUDIT_ACTIONS.REFUNDED]: "ຄືນເງິນ",
};

const STATUS_LABELS: Record<string, string> = {
  draft: "ພັກບິນ",
  paid: "ຊຳລະແລ້ວ",
  partial: "ຊຳລະບາງສ່ວນ",
  voided: "ຍົກເລີກ",
  refunded: "ຄືນເງິນ",
};

function pickRecord(v: unknown): Record<string, unknown> | null {
  if (!v || typeof v !== "object" || Array.isArray(v)) return null;
  return v as Record<string, unknown>;
}

export function posSaleAuditActionLabel(action: string): string {
  return LABELS[action] ?? action;
}

export function posSaleAuditDetail(
  before: unknown,
  after: unknown,
  meta: unknown,
): string | null {
  const b = pickRecord(before);
  const a = pickRecord(after);
  const m = pickRecord(meta);

  const parts: string[] = [];

  if (b?.status && a?.status && b.status !== a.status) {
    const from = STATUS_LABELS[String(b.status)] ?? String(b.status);
    const to = STATUS_LABELS[String(a.status)] ?? String(a.status);
    parts.push(`${from} → ${to}`);
  } else if (a?.status) {
    parts.push(STATUS_LABELS[String(a.status)] ?? String(a.status));
  }

  if (a?.total != null && a?.currency) {
    parts.push(`${a.total} ${a.currency}`);
  }

  if (m?.source === "workshop" && m?.workshopJobId) {
    parts.push("ຈາກໃບງານສ້ອມ");
  }

  if (a?.idempotentReplay === true) {
    parts.push("(ຊ້ຳ idempotency)");
  }

  return parts.length > 0 ? parts.join(" · ") : null;
}
